<template>
  <div class="manual-rune-img" :class="classes">
    <SvgIcon class="manual-rune-img__vortex" size="120" name="vortex" />
    <div class="manual-rune-img__rune-container">
      <img
        class="manual-rune-img__rune"
        :src="src"
        :alt="title"
        :title="title"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualRuneImg",
  props: {
    src: String,
    title: String,
    big: Boolean
  },
  computed: {
    classes() {
      return {
        "manual-rune-img_big": this.big
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".manual-rune-img";

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rune {
  0%,
  100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(0, -3px);
  }
  75% {
    transform: translate(0, 3px);
  }
}

.manual-rune-img {
  width: 178px;
  height: 178px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &__rune-container {
    transform: translate(-50%, -50%) scale(0.75);
    position: absolute;
    top: 50%;
    left: 50%;
  }

  &__rune {
    filter: drop-shadow(0 0 20px currentColor);
  }

  &__vortex {
    opacity: 0.3;
    filter: drop-shadow(0 0 10px currentColor);
    animation: rotate 6s infinite linear;
  }

  &_big {
    #{$p}__rune-container {
      transform: translate(-50%, -50%);
    }
    #{$p}__rune {
      animation: rune 2s infinite linear;
    }
    #{p}__vortex {
      animation: rotate 4s infinite linear;
    }
  }

  @include breakpoint("xs-only") {
    width: 160px;
  }
}
</style>
